import { render, staticRenderFns } from "./BlukOrder.vue?vue&type=template&id=ed626a78&scoped=true&"
import script from "./BlukOrder.vue?vue&type=script&lang=js&"
export * from "./BlukOrder.vue?vue&type=script&lang=js&"
import style0 from "./BlukOrder.vue?vue&type=style&index=0&id=ed626a78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed626a78",
  null
  
)

export default component.exports